<div class="empresa-selecao">
  <ul class="empresa-lista" role="list">
    <li *ngFor="let empresa of empresas">
      <button
        type="button"
        class="empresa-item"
        [disabled]="loading"
        (click)="onEscolher(empresa.ref)"
      >
        <i class="pi pi-building empresa-item-icon" aria-hidden="true"></i>
        <span class="empresa-item-nome">{{ empresa.nome }}</span>
        <i class="pi pi-chevron-right empresa-item-arrow" aria-hidden="true"></i>
      </button>
    </li>
  </ul>

  <div class="login-error" *ngIf="errorMessage">
    <i class="pi pi-exclamation-triangle"></i>
    <span>{{ errorMessage }}</span>
  </div>

  <div class="form-link-row">
    <a class="form-link" (click)="onTrocar()" href="javascript:void(0)">
      <i class="pi pi-arrow-left"></i> {{ trocarLabel }}
    </a>
  </div>
</div>
